module.exports = __webpack_public_path__ + "img/AL273LS-2.b07ad6a7.jpg";